import { Pipe, PipeTransform } from '@angular/core';
import { BookingItem, TravelBookingItemMinimal } from '../../api/models';
import { enumBookingStatus } from '../utils/enum-booking-status';

export enum enumGmgAdhesionCategory {
  CONFIRMED = 'confirmed',
  UNCONFIRMED = 'unconfirmed',
  WITHDRAWN = 'withdrawn',
  STANDARD = 'standard',
}
@Pipe({
  name: 'gmgAdhesionCategory',
})
export class GmgAdhesionCategoryPipe implements PipeTransform {
  transform(
    booking: TravelBookingItemMinimal | BookingItem,
    gmgFinalizedOn?: string,
  ): enumGmgAdhesionCategory {
    const beforeFinalization =
      !gmgFinalizedOn ||
      new Date(booking.created_on) < new Date(gmgFinalizedOn);

    if (booking.gmg_adh_confirmed) {
      return enumGmgAdhesionCategory.CONFIRMED;
    }
    if (
      beforeFinalization &&
      (booking.status.id === enumBookingStatus.REFUNDED ||
        booking.status.id === enumBookingStatus.PENDING_REFUND)
    ) {
      return enumGmgAdhesionCategory.WITHDRAWN;
    }
    if (beforeFinalization) {
      return enumGmgAdhesionCategory.UNCONFIRMED;
    }
    return enumGmgAdhesionCategory.STANDARD;
  }
}
